import React from 'react';
import { useFetchResponseTimeForStep } from '../../hooks/useFetchResponseTimeForStep';
import { format } from 'date-fns';
import { api_auth } from '../../../../common/globals/constants';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Alert } from '@mui/material';
import { Box } from '@material-ui/core';
import { ResponseTimeForStep } from '../../../../components/IndividualCharts/ResponseTime/ResponseTimeForStep';

const URL_PARAMS = ({ objetivoId, periodo, pasoId }) => {
  let fechaInicio = '';
  let fechaTermino = '';
  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('user', user);
  URL.append('key', api_auth);
  URL.append('token', token);
  URL.append('horarioId', '0');
  URL.append('objetivoId', objetivoId);
  URL.append('t', periodo.period);
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  URL.append('pasoId', pasoId);
  return URL;
};

export const ResponseTimeForStepChart = React.memo(({ objetivoId, pasoId }) => {
  const { filterPeriod, refreshTime } = useDynamicViewState();

  const {
    data: dataResponseTimeForStep,
    isLoading,
    error,
    isFetching,
  } = useFetchResponseTimeForStep({
    urlParams: URL_PARAMS({
      objetivoId,
      periodo: filterPeriod,
      pasoId,
    }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getDetalleRendimientoGlobalPasoCustom'
        : 'getDetalleRendimientoGlobalPaso',
    refreshTime,
  });

  if (isLoading || isFetching) return <AtCircularProgress />;
  if (error) return <Alert severity="error">Error al cargar los datos.</Alert>;

  return (
    <Box>
      <ResponseTimeForStep externalData={dataResponseTimeForStep} />
    </Box>
  );
});
